export const modalName = (state) => state.modalName;
